import { LogoWallTextAlignment, stripInvisibles } from '@workspace/constants';

export const getTextAlignClass = (align?: string): string => {
  const a = stripInvisibles(align || '')
    .trim()
    .toLowerCase();
  if (a === LogoWallTextAlignment.Left) return 'text-left';
  if (a === LogoWallTextAlignment.Right) return 'text-right';
  if (a === LogoWallTextAlignment.Center || a === 'middle') return 'text-center';
  return 'text-center';
};
